import { checkParams, zeroUnit, soFarDate } from '../../utils'
import { hasValue } from '../../utils/order'

export default function() {
	const { order, injured, setting } = this
	const injuredInfo = injured.injuredInfo || ''

	let arr = []
	const IDInfo = {
		title: '身份信息',
		children: [
			{ type: '0003', picName: '伤者身份证正面' },
			{ type: '0004', picName: '伤者身份证反面' },
			// { type: '0001', picName: '身份证明照' },
			{ type: '0002', picName: '对比照' },
		],
	}
	IDInfo.children = IDInfo.children.concat([
		{ type: '1201', picName: '户口本户主页' },
		{ type: '1202', picName: '户口本家庭成员页' },
	])
	arr.push(IDInfo)

	if (
		!injured.caregiversDto ||
		!injured.caregiversDto.hasCaregivers ||
		injured.caregiversDto.hasCaregivers !== '0'
	) {
		arr.push({
			title: '护理人材料',
			children: [
				{ type: '0801', picName: '护理人照片' },
				{ type: '0802', picName: '护理人资料' },
			],
		})
	}

	const injuryInfo = {
		title: '伤情照片',
		children: [],
	}
	injuryInfo.children = injuryInfo.children.concat([
		{ type: '0109', picName: '居住地大门照' },
		{ type: '0110', picName: '门牌号' },
		{ type: '0111', picName: '居住类证明' },
	])
	injuryInfo.children = injuryInfo.children.concat([
		{ type: '0104', picName: '伤者全身照' },
		{ type: '0105', picName: '受伤局部照' },
	])
	arr.push(injuryInfo)

	const condition = {
		title: '病情资料',
		desc: `（要求：医嘱、每日费用清单、影像片（必传）。诊断证明、门诊病历本、检查报告、三个类型最少上传其中一种。）`,
		children: [],
	}
	condition.children = condition.children.concat([
		{ type: '0502', picName: '医嘱' },
		{ type: '0503', picName: '每日费用清单' },
	])
	condition.children = condition.children.concat([
		{ type: '0201', picName: '诊断证明' },
		{ type: '0202', picName: '门诊病历本' },
		{ type: '0203', picName: '检查报告' },
		{ type: '0501', picName: '影像片-片子全貌' },
		{ type: '050101', picName: '影像片-片头' },
		{ type: '050102', picName: '影像片-受伤细节' },
	])

	arr.push(condition)

	if (hasValue(injuredInfo.disability) && injuredInfo.disability !== '01') {
		arr.push({
			title: '伤残等级报告',
			children: [{ type: '0c01', picName: '伤残等级报告' }],
		})
	}

	arr.push({
		title: '电子签名',
		slot: 'sign',
	})

	const signIn = {
		title: '签到',
		children: [],
	}
	let mediaInfoList = injured.mediaInfoList || []
	if (mediaInfoList.find(item => item.type === '0402')) {
		signIn.children.push({ type: '0402', picName: '作业人员和伤者合照' })
	} else if (mediaInfoList.find(item => item.type === '0401')) {
		signIn.children.push({ type: '0401', picName: '作业人员和床头卡合照' })
	} else if (mediaInfoList.find(item => item.type === '0403')) {
		signIn.children.push({ type: '0403', picName: '本人与居住地门牌合照' })
	} else {
		signIn.children.push({ type: '0405', picName: '本人与医院大门合照' })
	}

	arr.push(signIn)

	if (this.isCarInsurance) {
		if (order.hasManual === '1' && !this.isResurveyNotInHospital) {
			arr.push({
				title: '服务手册',
				children: [{ type: '1001', picName: '伤者和服务手册合照' }],
			})
		}
	} else {
		if (order.hasManual === '1' && !this.isResurveyNotInHospital) {
			arr.push({
				title: '联络卡',
				children: [{ type: '1002', picName: '伤者和联络卡合照' }],
			})
		}
	}

	if (
		hasValue(injuredInfo.injuredSite) &&
		injuredInfo.injuredSite.includes('01')
	) {
		arr.push({
			title: '伤者活动视频',
			video: true,
			type: '0001',
			children: [{ type: '0001', picName: '伤者活动视频' }],
		})
	}

	arr.push({
		title: '银行卡',
		desc: '（非必传）',
		children: [{ type: '0601', picName: '银行卡' }],
	})

	arr.push(
		{
			title: '其他',
			desc: '（非必传）',
			children: [{ type: '0900', picName: '其他' }],
		},
		{
			title: '视频信息',
			video: true,
			desc: '（非必传）',
		}
	)

	return arr
}
